import { API_URL } from './Constants';

// Cache theo code để Header + Footer không gọi API 2 lần trong 1 lần tải trang.
// Lưu promise (không phải kết quả) để 2 lời gọi đồng thời cũng dùng chung 1 request.
const menuCache = {};

class MenuApi {
    /**
     * Lấy danh sách mục menu công khai theo code ('header' / 'footer').
     * Trả về mảng [{id, name, url, order}] đã lọc active và sắp xếp theo order tăng dần,
     * hoặc null nếu có lỗi / không tìm thấy menu (caller sẽ dùng dữ liệu mặc định).
     */
    static getMenuForCode = async (code) => {
        if (!code) return null;
        const key = String(code).toLowerCase();
        if (menuCache[key] === undefined) {
            menuCache[key] = MenuApi.fetchMenuForCode(key);
        }
        return menuCache[key];
    };

    static fetchMenuForCode = async (key) => {
        try {
            const [menusRes, itemsRes] = await Promise.all([
                fetch(API_URL + '/menus'),
                fetch(API_URL + '/menu-items'),
            ]);
            if (!menusRes.ok || !itemsRes.ok) return null;

            const menus = await menusRes.json();
            const items = await itemsRes.json();
            if (!Array.isArray(menus) || !Array.isArray(items)) return null;

            const menu = menus.find(
                (m) => m && m.code && String(m.code).toLowerCase() === key
            );
            if (!menu) return null;

            return items
                .filter((it) => it && it.menu === menu.id && it.active === true)
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .map((it) => ({ id: it.id, name: it.name, url: it.url, order: it.order }));
        } catch (error) {
            console.error('MenuApi.getMenuForCode error:', error);
            return null;
        }
    };
}

export default MenuApi;
